module.exports = __webpack_public_path__ + "static/fonts/iconfont.86dd0788.woff2";